import { createSelector } from "reselect";
import { isPccSelector } from "src/selectors/config_selectors";

export const woundSummaryPdfEnabledSelector = createSelector(
  isPccSelector,
  isPcc => !isPcc
);
